// ScriptureConnections — conexões bíblicas canônicas (contrato v1.1).
// Agrupa SEMPRE por theological_function (nunca por índice). Silêncio elegante
// quando vazio. theological_function bruto e *_meta nunca são exibidos.
import React from "react";
import { ArrowRight } from "lucide-react";
import { BibleRefLink } from "../lib/bibleRef";

const ORDER = [
  ["fundamento", "Fundamento"],
  ["desenvolvimento", "Desenvolvimento"],
  ["aplicacao", "Aplicação"],
];

export const ScriptureConnections = ({ connections, testidPrefix = "scripture-connection" }) => {
  const items = ORDER.map(([fn, label]) => ({
    fn,
    label,
    conn: (Array.isArray(connections) ? connections : []).find(
      (c) => c && c.theological_function === fn && (c.reference || "").trim(),
    ),
  })).filter((x) => x.conn);
  if (!items.length) return null;
  return (
    <div data-testid={`${testidPrefix}s`} className="space-y-3">
      {items.map(({ fn, label, conn }) => (
        <BibleRefLink
          key={fn}
          refText={conn.reference}
          testid={`${testidPrefix}-${fn}`}
          className="group block rounded-2xl bg-white border border-gold/30 hover:border-gold/70 hover:shadow-sm transition-all p-4 sm:p-5"
        >
          <span className="flex items-center justify-between gap-3">
            <span className="text-[10px] uppercase tracking-[0.3em] text-gold">{label}</span>
            <ArrowRight className="w-3.5 h-3.5 text-navy/30 group-hover:text-gold group-hover:translate-x-0.5 transition-all" aria-hidden="true" />
          </span>
          <span className="mt-1.5 block text-sm uppercase tracking-widest text-navy tabular-nums">
            {conn.reference}
          </span>
          {conn.verse_text && (
            <span className="mt-2 block text-navy/80 italic text-sm leading-[1.7]">
              {conn.verse_text}
            </span>
          )}
        </BibleRefLink>
      ))}
    </div>
  );
};
